import CourseIcon from "../../assets/icons/CourseIcon";
import DashboardIcon from "../../assets/icons/DashboardIcon";
import ProfileIcon from "../../assets/icons/ProfileIcon";

// Navbar menu list
export const menuItems = [
  { key: "courses", label: "কোর্স সমূহ" },
  { key: "jobs", label: "চাকরি" },
  { key: "success-story", label: "সফলতার গল্প" },
  { key: "user-manual", label: "ব্যবহারবিধি" },
];

// Navbar profile menu list
export const userMenuItems = [
  { key: "dashboard", label: "ড্যাশবোর্ড", icon: DashboardIcon },
  { key: "profile", label: "আমার প্রোফাইল", icon: ProfileIcon },
  { key: "courses", label: "কোর্স সমূহ", icon: CourseIcon },
  // { key: "setting", label: "সেটিংস", icon: SettingIcon },
];
